import { render, staticRenderFns } from "./ValueVoucherCancellation.vue?vue&type=template&id=60a46919&scoped=true"
import script from "./ValueVoucherCancellation.vue?vue&type=script&lang=js"
export * from "./ValueVoucherCancellation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a46919",
  null
  
)

export default component.exports